var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3a1 1 0 011-1h9.314a1 1 0 01.708.293l8.003 8.005a2.864 2.864 0 010 4.037l-.002.002-6.678 6.68a2.863 2.863 0 01-4.051 0l-8-7.993A1 1 0 012 12.317V3zm2 1v7.902l7.709 7.702a.865.865 0 001.22 0l6.677-6.678.001-.001a.863.863 0 000-1.216L11.9 4H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.467 8.357a.893.893 0 100-1.786.893.893 0 000 1.786z"
  })));
}
export default SvgMarkOutline;